export default "__VITE_ASSET__361b7c99__"